/**
 * MODULE: assistantContextChips.ts
 * PURPOSE: Human labels for assistant page + routed topic/tool chips (Notion / Perplexity-style).
 * RECENT: 2026-06-06 [2.2.1312] — Brain-rail labels for **`assistant_platform_tools`**, **`create_contact`** chips.
 */

const TOPIC_LABELS: Record<string, string> = {
  'research-account': 'Company research',
  'research-person': 'Contact lookup',
  'enrich-contact': 'Contact enrichment',
  'stage-lookup': 'Deal stage',
  'build-account-brief': 'Account brief',
  'draft-outreach': 'Outreach',
  'draft-follow-up': 'Follow-up email',
  'schedule-meeting': 'Schedule meeting',
  'log-activity': 'Log activity',
  'create-task': 'Create task',
  'update-opportunity': 'Update deal',
  'team-messaging': 'Messaging',
  'sales-hub-content': 'Sales Hub',
  'pipeline-by-stage': 'Pipeline by stage',
  'top-accounts': 'Top accounts',
  'top-reps': 'Top reps',
  'forecast-summary': 'Forecast',
  'export-report': 'Export report',
  'manage-canvases': 'Canvases',
  'manage-widgets': 'Widgets',
  assistant_platform_tools: 'Workspaces',
  create_contact: 'Create contact',
  champion_internal_sell: 'Champion internal sell',
  reengage_quiet_champions: 'Re-engage champions',
  quiet_champions: 'Quiet champions',
  general_chat: 'General',
  company_research: 'Company research',
  langflow_agent: 'Assistant',
};

/** Prefer topic slug; fall back to orchestration query_type. */
export function formatAssistantTopicLabel(slugOrType: string): string {
  const key = slugOrType.trim().toLowerCase();
  if (!key) return '';
  if (TOPIC_LABELS[key]) return TOPIC_LABELS[key];
  return key
    .split(/[-_]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function shouldShowAssistantTopicChip(slugOrType: string): boolean {
  const key = slugOrType.trim().toLowerCase();
  return Boolean(key) && key !== 'general_chat' && key !== 'general';
}
